import React from 'react';
import styled, { css } from 'styled-components';

const SelectBoxStyles = styled.select`
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  background-color: #fff;
  background-image: url("data:image/svg+xml,%3Csvg width='12' height='7' viewBox='0 0 12 7' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.944291 -9.66521e-07L5.28745e-07 0.951864L6 7L12 0.951865L11.0557 -8.25524e-08L6 5.09627L0.944291 -9.66521e-07Z' fill='lightgray'/%3E%3C/svg%3E");
  background-repeat: no-repeat, repeat;
  background-position: right 14px top 50%, 0 0;
  display: block;
  font-family: Basier Circle;
  font-weight: 400;
  font-size: 13px;
  letter-spacing: -0.2px;
  color: #000;
  line-height: 1.2;
  padding-right: 40px;
  padding-left: 18px;
  box-sizing: border-box;
  min-width: 70px;
  margin: 12px 0 0 0;
  ${props => {
    if (props.noMargin) {
      return css`
        margin: 0px !important;
      `;
    }
  }}
  border: 1px solid #DDDDDD;
  border-radius: 49px;
  height: 35px;
  text-align: left;
  cursor: pointer;

  > :focus {
    border: none !important;
  }

  :hover {
    border-color: #000;
  }

  &:disabled {
    color: #aaaaaa;

    :hover {
      border-color: #dddddd;
    }
  }

  ${props => {
    if (props.variant === 'OptionsField') {
      return css`
        background-image: url("data:image/svg+xml,%3Csvg width='11' height='6' viewBox='0 0 12 7' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.944291 -9.66521e-07L5.28745e-07 0.951864L6 7L12 0.951865L11.0557 -8.25524e-08L6 5.09627L0.944291 -9.66521e-07Z' fill='black'/%3E%3C/svg%3E");
        height: 30px;
        padding-right: 29px;
        margin: 0;
        font-size: 12px !important;
      `;
    }
  }}
`;

const Container = styled.div``;

function PillSelectBox(props) {
  return (
    <Container>
      <SelectBoxStyles
        disabled={props.disabled || false}
        noMargin={props.noMargin}
        id={props.id}
        name="label"
        value={props.value}
        variant={props.variant}
        onChange={props.onChange}
      >
        {props.children}
      </SelectBoxStyles>
    </Container>
  );
}

export default PillSelectBox;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/PillSelectBox/index.jsx